import React, { useRef, useEffect } from 'react';

import { gsap } from 'gsap'

import _ from 'lodash'
import { areAnglesWithin } from '../are_angles_within.js'

import SPAN_TEXTURE from "images/span_texture.png"

_.templateSettings.interpolate = /#{([\s\S]+?)}/g;

const optRectTemplate = _.template("top-[#{top}px] left-[#{left}px]	w-[#{width}px] h-[#{height}px] rotate-[#{rotation}deg]");
const spaceJoin = (...args) => args.flat().join(' ')

const Key = ({ x, y, width, height, angle, className, overed })=>{
	const rotation_deg = angle * (180 / Math.PI);
	const key_ref = useRef()

	useEffect(()=>{
		gsap.to(key_ref.current.style, {
			opacity: overed ? 1 : 0
		})
	}, [overed])

	return (
		<span
			ref={key_ref}
			className={spaceJoin('bg-blue-500', className)}
			style={{
				position: 'absolute',
				width: width,
				height: height,
				top: y,
				left: x,
				transform: `translate(-50%, -50%) rotate(${rotation_deg}deg)`,
				backgroundImage: `url(${SPAN_TEXTURE})`,
				borderRadius: '3px',
				filter: 'drop-shadow(1px 1px 4px rgba(255, 255, 255, 1))',
				opacity: 0
    			//backdropFilter: "opacity(0.4)"
			}}
		></span>
	)
}

export default React.memo(Key)